import { IApplicationData } from "./common";
export class HangUpAction implements IApplicationData {
  
  constructor() {
    this.name = "Hangup";
  }

  name: string;
}
